import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Logo from './Logo';
import { navLinks } from '../data/site';

const { FiMenu, FiX, FiArrowUpRight } = FiIcons;

function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const linkClass = ({ isActive }) =>
    `relative text-[12px] font-bold uppercase tracking-[0.14em] transition-colors hover:text-brick ${
      isActive ? 'text-brick' : 'text-ink'
    }`;

  return (
    <header
      className={`sticky top-0 z-40 transition-all duration-300 ${
        scrolled ? 'bg-bone/95 shadow-[0_8px_30px_rgba(20,17,15,0.08)] backdrop-blur' : 'bg-bone'
      }`}
    >
      <div className="wrap flex h-[78px] items-center justify-between">
        <Link to="/" aria-label="US Paver Co. home">
          <Logo />
        </Link>
        <nav className="hidden items-center gap-10 lg:flex" aria-label="Main navigation">
          {navLinks.map((l) => (
            <NavLink key={l.to} to={l.to} className={linkClass}>
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" className="btn btn-dark !px-6 !py-3.5">
            Request a Quote <SafeIcon icon={FiArrowUpRight} className="text-base" />
          </Link>
        </nav>
        <button
          type="button"
          className="text-2xl lg:hidden"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <SafeIcon icon={open ? FiX : FiMenu} />
        </button>
      </div>
      {open && (
        <nav className="wrap flex flex-col gap-1 border-t border-ink/10 pb-6 pt-3 lg:hidden" aria-label="Mobile navigation">
          {navLinks.map((l) => (
            <NavLink key={l.to} to={l.to} className={(s) => `${linkClass(s)} border-b border-ink/10 py-4`}>
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" className="btn btn-brick mt-4">
            Request a Quote
          </Link>
        </nav>
      )}
    </header>
  );
}

export default Header;
